<template>
    <button @click="reset" type="button" class="btn btn-reset">Reset</button>
</template>

<script>
    import Color             from "../../../../../Lib/Color";
    import DraftSwatch       from "../../../Store/DraftSwatch";
    import UsesActivePalette from "../Palette/UsesActivePalette";

    export default {
        name: "ResetButton",
        extends: UsesActivePalette,

        methods: {
            reset() {
                if(!this.activeSwatch) return;
                let draft = new DraftSwatch();

                draft.animateColorValues(Color.fromRGB(this.activeSwatch.color));
            },
        },

        mounted() {
            this.reset();
        }
    }
</script>

<style scoped>

</style>